import { render, staticRenderFns } from "./PayDet.vue?vue&type=template&id=fc7a6ed0&scoped=true"
import script from "./PayDet.vue?vue&type=script&lang=js"
export * from "./PayDet.vue?vue&type=script&lang=js"
import style0 from "./PayDet.vue?vue&type=style&index=0&id=fc7a6ed0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7a6ed0",
  null
  
)

export default component.exports